import { Component, OnInit } from '@angular/core';
import {
  NavigationEnd,
  NavigationStart,
  Router,
  Event as RouterEvent,
  RouterOutlet,
} from '@angular/router';
import { routes } from './shared/routes/routes';
import { environment } from '../environments/environment';
import { CommonService } from './shared/common/common.service';
import { DataService } from './shared/data/data.service';
import { SidebarService } from './shared/sidebar/sidebar.service';
import { url } from './shared/models/models';
import { NgClass } from '@angular/common';
import { ModalComponent } from './feature-module/modal/modal.component';
import { MessagingService } from './services/messaging.service';
import { filter } from 'rxjs';
import { DependentModalComponent } from './feature-module/dependent-modal/dependent-modal.component';
import { PopupService } from './services/popup.service';
import { PatientsModule } from './feature-module/patients/patients.module';
import { IncomingCallComponent } from './feature-module/patients/incoming-call/incoming-call.component';
import { PipOverlayComponent } from './components/pip-overlay/pip-overlay.component';
import { MissedCallPopupComponent } from './feature-module/patients/missed-call-popup/missed-call-popup.component';
import { MissedCallService } from './shared/services/missed-call.service';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgClass,
    ModalComponent,
    PatientsModule,
    DependentModalComponent,
    IncomingCallComponent,
    PipOverlayComponent,
    MissedCallPopupComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  public routes = routes;
  title = 'template';
  base = '';
  page = '';
  last = '';
  public miniSidebar = false;
  public expandMenu = false;
  public mobileSidebar = false;
  public showMiniSidebar = false;
  incomingCallActive = false;
  constructor(
    private common: CommonService,
    private router: Router,
    private data: DataService,
    private sidebar: SidebarService,
    private messagingService: MessagingService,
    public popupService: PopupService,
    private missedCallService: MissedCallService,
  ) {
    this.common.currentRoute = this.router.url;
    this.common.base.subscribe((res: string) => {
      this.base = res;
    });
    this.common.page.subscribe((res: string) => {
      this.page = res;
    });
    this.common.last.subscribe((res: string) => {
      this.last = res;
    });
    this.router.events.subscribe((data: RouterEvent) => {
      this.handleBtnClick();
      if (data instanceof NavigationStart) {
        this.getRoutes(data);
        this.mobileSidebar = false;
        localStorage.removeItem('isMobileSidebar');
        localStorage.removeItem('sidebarPosition');
      }
      if (data instanceof NavigationEnd) {
        this.showMiniSidebar = false;
      }
    });
    this.sidebar.toggleSideBar.subscribe((res: string) => {
      if (res == 'true') {
        this.miniSidebar = true;
      } else {
        this.miniSidebar = false;
      }
    });
    this.sidebar.toggleMobileSideBar.subscribe((res: string) => {
      if (res == 'true' || res == 'true') {
        this.mobileSidebar = true;
      } else {
        this.mobileSidebar = false;
      }
    });
    this.sidebar.expandSideBar.subscribe((res) => {
      this.expandMenu = res;
      if (res == false && this.miniSidebar == true) {
        this.data.adminSidebar.map((mainMenus) => {
          mainMenus.menu.map((resMenu) => {
            resMenu.showSubRoute = false;
          });
        });
      }
      if (res == true && this.miniSidebar == true) {
        this.data.adminSidebar.map((mainMenus) => {
          mainMenus.menu.map((resMenu) => {
            const menuValue = sessionStorage.getItem('menuValue');
            if (menuValue && menuValue == resMenu.menuValue) {
              resMenu.showSubRoute = true;
            } else {
              resMenu.showSubRoute = false;
            }
          });
        });
      }
    });
    this.sidebar.toogleUserSidebar.subscribe((res: string) => {
      if (res == 'true') {
        this.showMiniSidebar = true;
      } else {
        this.showMiniSidebar = false;
      }
    });

    this.common.setUserDetails();
  }
  ngOnInit(): void {
    this.loadFavicon();
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.common.initSessionMonitor();
      } else {
      }
    });
    this.messagingService.requestPermissionAndGetToken();
    this.messagingService.listenForMessages();
    this.requestNotificationPermission();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.common.previousRoute = this.common.currentRoute;
        this.common.currentRoute = event.urlAfterRedirects;
        const skipRoutes = ['/patients/tele-consult-detail'];
        if (
          !skipRoutes.includes(this.common.previousRoute) &&
          !skipRoutes.includes(this.common.previousRoute)
        ) {
          localStorage.removeItem('currentRowIndex');
        }
      });

    localStorage.removeItem('currentRowIndex');
    localStorage.removeItem('pat_auth');
    this.missedCallService.showPendingMissedCallIfAny();
  }
  loadFavicon(): void {
    const faviconUrl = `${environment.imageUrl}/misha_healthai.webp`;
    const favicon: HTMLLinkElement | null =
      document.querySelector('#appFavicon');

    if (favicon) {
      favicon.href = faviconUrl;
    }
  }

  requestNotificationPermission() {
    if ('Notification' in window && Notification.permission !== 'granted') {
      Notification.requestPermission().then((permission) => {
        console.log('Notification permission:', permission);
      });
    }
  }

  public getRoutes(events: url) {
    const splitVal = events.url.split('/');
    this.common.base.next(splitVal[1]);
    this.common.page.next(splitVal[2]);
    this.common.last.next(splitVal[3]);
  }

  handleBtnClick() {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (!isMobile) {
      return;
    }

    setTimeout(() => {
      document.querySelectorAll('.button_class').forEach((btn) => {
        btn.addEventListener('click', () => {
          btn.classList.add('clicked');
          setTimeout(() => {
            btn.classList.remove('clicked');
          }, 300);
        });
      });
    }, 0);
  }
}
